import { ShipmentStatus, DealerExchangeType } from "./enum";

// Exchange is valid if shipment has exchange id and exchange status is posted
export function childShipmentExchangeIsValid(shipmentData, configPerm) {
  const correctStatus =
    shipmentData.status === ShipmentStatus.Posted ||
    (configPerm["CoreService.AdminShipments"] && shipmentData.status === ShipmentStatus.Completed);

  return shipmentData.childShipmentId && correctStatus && !shipmentData.childShipment?.onHold;
}

export function childShipmentExchangeOfferIsValid(shipmentData, configPerm) {
  return childShipmentExchangeIsValid(shipmentData, configPerm) && shipmentData.userAcceptedExchangeOffer === undefined;
}

// Exchange is valid if shipment has exchange id, exchange status is posted, and exchange type is unordered
export function parentShipmentExchangeIsValid(shipmentData, configPerm) {
  const correctStatus =
    shipmentData.status === ShipmentStatus.Posted ||
    (configPerm["CoreService.AdminShipments"] && shipmentData.status === ShipmentStatus.Completed);

  return (
    shipmentData.parentShipmentId &&
    correctStatus &&
    !shipmentData.parentShipment?.onHold &&
    shipmentData.dealerExchangeType === DealerExchangeType.Unordered
  );
}

export function parentShipmentExchangeOfferIsValid(shipmentData, configPerm) {
  return (
    parentShipmentExchangeIsValid(shipmentData, configPerm) && shipmentData.userAcceptedExchangeOffer === undefined
  );
}
